// The Fácil/Difícil bonus the dice bar holds for the live sheet's next roll. The bar's controller writes it as its
// modifier changes; the sheet reads it for its rolls and takes it when one spends it, and the bar follows the reset.
let bonus = 0;
const listeners = new Set<(value: number) => void>();

export const pendingBonus = () => bonus;

export function setPendingBonus(value: number) {
	if (value === bonus) return;
	bonus = value;
	for (const listener of [...listeners]) listener(value);
}

export function takePendingBonus() {
	const value = bonus;
	setPendingBonus(0);
	return value;
}

export function onPendingBonus(listener: (value: number) => void) {
	listeners.add(listener);
	return () => void listeners.delete(listener);
}
